<!--
@component
Renders sanitized GitHub-flavored Markdown.
-->
<script lang="ts">
  import rehypeRaw from "rehype-raw";
  import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
  import type { ComponentProps } from "svelte";
  import { Markdown, type Plugin } from "svelte-exmarkdown";
  import { gfmPlugin } from "svelte-exmarkdown/gfm";

  const rehypeSanitizeSchema = {
    ...defaultSchema,
    protocols: {
      ...defaultSchema.protocols,
      src: [...(defaultSchema.protocols?.src || []), "themed-image"],
    },
  };

  const defaultPlugins: Plugin[] = [
    // GitHub Flavored Markdown (GFM) - tables, auto-links, strikethrough, etc.
    gfmPlugin(),
    // Parse raw nodes into HTML HAST trees
    { rehypePlugin: rehypeRaw },
    // Sanitize the HTML HAST trees
    { rehypePlugin: [rehypeSanitize, rehypeSanitizeSchema] },
  ];

  let { plugins, ...props }: ComponentProps<typeof Markdown> = $props();

  let combinedPlugins = $derived([...defaultPlugins, ...(plugins ?? [])]);
</script>

<Markdown {...props} plugins={combinedPlugins} />
